module.exports = __webpack_public_path__ + "img/btn_CNN.23d06a1b.png";